import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { typographyOverrides } from "AttendanceForm/Theme/Overrides/TypographyOverrides";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const PageNotFound = (): React.ReactElement => {
  const { t: tcommon } = useTranslation("common");
  const styles = useStyles();

  return (
    <div>
      <Box
        paddingTop={30}
        paddingBottom={3}
        width="100%"
        flexDirection="row"
        display="flex"
        justifyContent="center"
      >
        <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
          <Typography variant="h1" color="primary" gutterBottom>
            {tcommon("pageNotFound")}
          </Typography>
          <Typography style={typographyOverrides.h6} color="primary" gutterBottom>
            {tcommon("pageNotFoundDescription")}
            <Link to={"/attendanceform/trainerdetails"} className={styles.link}>
              {tcommon("home")}
            </Link>
            {tcommon("page")}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  link: {
    fontWeight: "bold",
    textDecoration: "underline",
  },
}));
